module.exports = __webpack_public_path__ + "assets/img/rakumart-costes-envio.fa0bfbfd.jpg";